import { merge, transform, isEqual, isObject } from 'lodash';
import { DATA_TYPE } from '@/store/modules/cards/constants';

export default {
  computed: {
    maxWidth() {
      if (this.isMobile) return '100%';

      return '970px';
    },
  },
  methods: {
    differenceBetweenTwoObject(oldFilters, newFilters) {
      const mergedFilters = merge({}, oldFilters, newFilters);

      return transform(mergedFilters, (result, value, key) => {
        if (!isEqual(value, oldFilters[key])) {
          result[key] = this.filterValue(oldFilters, value, key);
        }
        if (!isEqual(value, newFilters[key])) {
          result[key] = this.filterValue(newFilters, value, key);
        }
      });
    },
    applyFallbackToFilters(filters, dataType) {
      const sacStatusValue = dataType === DATA_TYPE.SAC
        ? this.$t('mixins.filtersModel.filters.sac_status_sac')
        : this.$t('mixins.filtersModel.filters.sac_status_other');
      const channelValue = dataType === DATA_TYPE.LISTENING
        ? this.$t('mixins.filtersModel.filters.channels_listening')
        : this.$t('mixins.filtersModel.filters.channels_proprietary');

      const FILTERS = {
        sac_status: sacStatusValue,
        names: this.$t('mixins.filtersModel.filters.names'),
        channels: channelValue,
        channels_listening: this.$t('mixins.filtersModel.filters.channels_listening'),
        themes: this.$t('mixins.filtersModel.filters.themes'),
        pids: this.$t('mixins.filtersModel.filters.pids'),
        genders: this.$t('mixins.filtersModel.filters.genders'),
        polarities: this.$t('mixins.filtersModel.filters.polarities'),
        tags: this.$t('mixins.filtersModel.filters.tags'),
        favorite: this.$t('mixins.filtersModel.filters.favorite'),
        dark_post: this.$t('mixins.filtersModel.filters.dark_post'),
        sac_last_status: this.$t('mixins.filtersModel.filters.sac_last_status'),
        sac_replier: this.$t('mixins.filtersModel.filters.sac_replier'),
        sac_type: this.$t('mixins.filtersModel.filters.sac_type'),
        pages: this.$t('mixins.filtersModel.filters.pages'),
        uids: this.$t('mixins.filtersModel.filters.uids'),
        contracts: this.$t('mixins.filtersModel.filters.contracts'),
        bots: this.$t('mixins.filtersModel.filters.bots'),
        category: this.$t('mixins.filtersModel.filters.category'),
      };

      const FILTERS_NEGATION = [
        'tags',
        'names',
        'themes',
        'uids',
      ];

      if (!dataType) {
        return filters.map((filter) => FILTERS[filter] || filter);
      }
      return filters.map((filter) => {
        if (this.card.props.filter &&
          FILTERS_NEGATION.includes(filter) &&
          this.card.props.filter[filter]?.value.some(value => value?.indexOf('-') === 0)) {
          return `-${FILTERS[filter]}` || `-${filter}`;
        }
        return FILTERS[filter] || filter;
      });
    },
    filterValue(filter, value, key) {
      return isObject(value) && isObject(filter[key]) ? this.differenceBetweenTwoObject(value, filter[key]) : value;
    },
    dateHasChange(actualDate, toDate) {
      const diffInStartDate = actualDate.start.diff(toDate.start, 'minutes') !== 0;
      const diffInEndDate = actualDate.end.diff(toDate.end, 'minutes') !== 0;

      return diffInStartDate || diffInEndDate;
    },
    filterMessage(value) {
      return value.length === 1 ? this.$t('mixins.filtersModel.selected') : this.$t('mixins.filtersModel.selectedPlural');
    },
    generateObjectToNegativationFilter(value) {
      return {
        text: value,
        shouldIgnore: false,
        value,
        hasIgnoreOption: true,
      };
    },
  },
};
